module.exports = __webpack_public_path__ + "static/media/0-2.6fd9254b.svg";